import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './AtfContent.scss';

function AtfContent(props) {
  const { content } = props;
  const [readMoreButton, setReadMoreButton] = useState(true);
  const [showReadMore, setShowReadMore] = useState(false);
  const changeAboutDataState = e => {
    e.preventDefault();
    if (!readMoreButton) {
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    }
    setReadMoreButton(!readMoreButton);
  };
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const readMoreCtn = document.getElementById('read-more-div');
      if (readMoreCtn) {
        const showReadMoreVal =
          document.getElementById('read-more-div').clientHeight > 84;
        if (showReadMore !== showReadMoreVal) {
          setShowReadMore(showReadMoreVal);
        }
      }
    }
  }, []);
  return (
    <div className={`${s.atfWrap} ${readMoreButton ? `` : s.readmoreextend}`}>
      <>
        {content && (
          <div className={s.atfIn}>
            <div id="read-more-div">
              <span dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </div>
        )}
        {content &&
          showReadMore && (
            <a className={s.read_more} onClick={changeAboutDataState}>
              {readMoreButton ? `Read More` : `Read Less`}
            </a>
          )}
      </>
    </div>
  );
}

AtfContent.propTypes = {
  content: PropTypes.string,
};

AtfContent.defaultProps = {
  content: '',
};

export default AtfContent;
